"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllyResurrectedEventArgs = void 0;
const EventType_1 = require("../EventType");
class AllyResurrectedEventArgs {
    constructor(allyId) {
        this.allyId = allyId;
        this.__type = EventType_1.EventType.AllyResurrected;
        this.__typeName = "AllyResurrected";
    }
}
exports.AllyResurrectedEventArgs = AllyResurrectedEventArgs;
